import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { Component, OnInit, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

@Component({
	selector: 'app-month-filter-package',
	templateUrl: './month-filter-package.component.html',
	styleUrls: ['./month-filter-package.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class MonthFilterPackageComponent implements OnInit {

	@Output() changeMonthEmit: EventEmitter<string> = new EventEmitter<string>();

	months = Array<object>();
	monthId: number;
	today: Date;
	monthsNamesShort: Array<string>;
	slideConfig = {
		slidesToShow : 8,
		slidesToScroll: 1,
		initialSlide: 4,
		arrows: true,
		dots: false,
		infinite: false,
		prevArrow : '<button type="button" class="slick-prev material-icons arrow"><span>&#xE5C5;</span></button>',
		nextArrow : '<button type="button" class="slick-next material-icons arrow"><span>&#xE5C5;</span></button>',
		draggable: false
	};

	constructor(private router: Router, private route: ActivatedRoute) { }

	setMonths() {
		this.today = new Date();
		let actualDate: Date;
		let monthNum: string;
		let monthTextSort: string;
		let year: number;
		for (let i = 12; i > 0; i -= 1) {
			actualDate = new Date(this.today.getFullYear(), this.today.getMonth() + 1 - i, 1);
			monthNum = ('0' + (actualDate.getMonth() + 1)).slice(-2);
			monthTextSort = this.monthsNamesShort[actualDate.getMonth()];
			year = actualDate.getFullYear();
			this.months.push({ monthTextSort: monthTextSort, month: monthNum, year: year });
		}
	}

	ngOnInit() {
		moment.locale('pt-br');
		this.monthsNamesShort = moment.monthsShort();
		this.setMonths();
		this.monthId = this.today.getMonth() + 1;
	}

	loadByMonth(month: any): void {
		const date = this.getFinalDate(month.month, month.year);
		this.changeMonthEmit.emit(date);
		this.monthId = month.month;
	}

	getFinalDate(month: string, year: string): string {
		return moment(year + '-' + month + '-' + moment(year + '-' + month, 'YYYY/MM').daysInMonth()).format('YYYY-MM-DD');
	}


}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/rate-package/month-filter/month-filter-package.component.ts